<template>
  <UiLangSelect
    v-if="options.length > 1"
    :modelValue="lang"
    :options="options"
    :ariaLabel="$t('W: Vælg sprog')"
    @update:modelValue="onLanguageChange" />
</template>

<script lang="ts">
import { i18n } from '@/locales'
import { useToast } from '@/globals/typescript/utils/toast'
import { useUserStore } from '@/stores/userStore'
import { adminApi } from '@/globals/typescript/utils/api/adminClient'
import type { ILangSelectOption } from '@team-milva/lab-components'
import {
  LAB_ADMIN_LANGUAGES,
  LOCALE_COUNTRY_CODES,
  LOCALE_NATIVE_NAMES,
  type TLabAdminLocale,
} from '@team-milva/lab-models/language'
import { mapState } from 'pinia'

export default {
  name: 'LangSelect',
  data() {
    return {
      lang: i18n.global.locale.value as TLabAdminLocale,
    }
  },
  computed: {
    ...mapState(useUserStore, ['currentUser']),
    options(): ILangSelectOption[] {
      return Object.values(LAB_ADMIN_LANGUAGES).map((lang) => ({
        value: lang.locale,
        code: lang.code,
        text: LOCALE_NATIVE_NAMES[lang.locale] ?? lang.name,
        countryCode: LOCALE_COUNTRY_CODES[lang.locale] ?? lang.locale,
      }))
    },
  },
  methods: {
    async onLanguageChange(value: string) {
      const previousLang = this.lang

      this.lang = value as TLabAdminLocale
      i18n.global.locale.value = value as TLabAdminLocale
      localStorage.setItem('lang', value)

      if (!this.currentUser) return

      const languageCode = Object.values(LAB_ADMIN_LANGUAGES).find(
        (lang) => lang.locale === value
      )?.code
      if (!languageCode) return

      try {
        const result = await adminApi('patch', '/users/{userID}', {
          path: { userID: this.currentUser.id },
          body: { languageCode },
        })
        if (!result.success) throw new Error(result.code)
      } catch (error) {
        console.error(error)
        useToast().error(this.$t('W: Kunne ikke gemme sprog'))
        this.lang = previousLang
        i18n.global.locale.value = previousLang
        localStorage.setItem('lang', previousLang)
      }
    },
  },
}
</script>
